import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AppDataProvider } from "./Data/BackEnd Data/FetchBackEndData";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppDataProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AppDataProvider>,
);
